import { Container } from "./Container";

export class Root extends Container {}
